import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const AccountList = lazy(() => import('../Pages/AccountList'));
const AddAccount = lazy(() => import('../Pages/AddAccount'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import AccountView from "../Pages/AccountView";
import EditAccount from "../Pages/EditAccount";
LoadingOverlay.propTypes = undefined;

function AccountRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/business/accounts"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AccountList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/list"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AccountList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/add"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AddAccount history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/view/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <AccountView history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/business/accounts/edit/:slack"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <EditAccount history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
        </Switch>
    );
};

export default AccountRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
